import { Injectable } from '@angular/core';

type Params = {
  action?: string;
  item_category?: string;
  item_name?: string;
  label?: string;
  section?: string;
  step?: string;
  type?: string;
  screen_name?: string;
  channel?: string;
  element_id?: string;
};

declare global {
  interface Window {
    dataLayer: any;
  }
}
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  endFlujo(params: Params) {
    this.eventAnalytics('endflujo', params);
  }

  btnClick(params: Params) {
    this.eventAnalytics('btn_click', params);
  }

  mensaje(params: Params) {
    this.eventAnalytics('mensaje', params);
  }

  pageView(params: Params) {
    this.eventAnalytics('page_view', params);
  }
  private eventAnalytics(eventName: string, params: Params) {
    const eventParams = {
      flow: 'estado situacion',
      category: 'autenticacion'
    };

    window.dataLayer.push({
      event: 'ga4.trackEvent',
      event_name: eventName,
      event_params: Object.assign({}, eventParams, params)
    });
  }
}
